import React from 'react';
import safelog from '@alife/bc-safe-log';
import * as I18n from 'src/utils/i18n';
import PropTypes from 'prop-types';
import './index.scss';

export default class SeaFreight extends React.Component {
  static propTypes = {
    productIsMarketGoods: PropTypes.bool,
    ipCountry: PropTypes.string,
  };

  componentDidMount() {
    safelog('/sc.details.seaFreightRendered', 'CLK', '', 'GET');
  }

  getCompareRates = () => {
    return (
      <span>
        <a
          className="sea-freight-compare-rates"
          href="//alibaba.freightos.com/?tracelog=pdp"
          target="_blank"
          onClick={this.handleCompareRatesClick}
        >
          {I18n.get('details_assurance_educate.seafreight.compare')}
        </a>
        <span className="sea-freight-split"> | </span>
      </span>
    );
  };

  handleClick = () => {
    safelog(
      '/sc.details.commonLogs',
      'CLK',
      'action=seaFreightMoreClick',
      'GET',
    );
  };

  handleCompareRatesClick = () => {
    safelog(
      '/sc.details.commonLogs',
      'CLK',
      'action=seaFreightCompareClick',
      'GET',
    );
  };

  render() {
    const { productIsMarketGoods, ipCountry } = this.props;
    const show =
      ipCountry !== 'CN' || window.location.search.indexOf('showCN') > -1;

    if (!productIsMarketGoods && show) {
      return (
        <div className="sea-freight">
          <img
            className="sea-freight-icon"
            src="//img.alicdn.com/tfs/TB1j8OMwAY2gK0jSZFgXXc5OFXa-15-16.svg"
            alt="global"
          />
          <span className="sea-freight-title">Alibaba.com Freight</span>
          <span className="sea-freight-split"> | </span>
          {this.getCompareRates()}
          <a
            className="sea-freight-link"
            href="//ship.alibaba.com/?tracelog=pdp"
            target="_blank"
            onClick={this.handleClick}
          >
            {I18n.get('details_assurance_educate.seafreight.more')}
          </a>
        </div>
      );
    }
    return null;
  }
}
